import React from "react";

const BLabsLogo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 120, height: 50 },
    default: { width: 160, height: 65 },
    large: { width: 240, height: 100 },
    xlarge: { width: 320, height: 130 },
  };

  const { width, height } = sizes[size] || sizes.default;

  return (
    <svg
      viewBox="0 0 200 80"
      width={width}
      height={height}
      className={className}
      aria-label="B-Labs - Stay Powered"
    >
      {/* B-Labs text - Bold white */}
      <text
        x="100"
        y="38"
        textAnchor="middle"
        fontFamily="'Outfit', 'Arial Black', sans-serif"
        fontSize="42"
        fontWeight="800"
        fill="#FFFFFF"
        letterSpacing="-1"
      >
        B-Labs
      </text>
      
      {/* Stay powered text - Script style neon yellow */}
      <text
        x="100"
        y="68"
        textAnchor="middle"
        fontFamily="'Pacifico', 'Brush Script MT', cursive"
        fontSize="22"
        fontWeight="400"
        fill="#FFD84D"
        style={{ fontStyle: "italic" }}
      >
        Stay powered
      </text>
      
      {/* Underline - neon yellow */}
      <line
        x1="45"
        y1="73"
        x2="155"
        y2="73"
        stroke="#FFD84D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* Subtle glow effect */}
      <defs>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
};

export default BLabsLogo;
